import { logger as r } from "../../shared-lib/index.js";
export function toggleLogging() {
  r.toggleLogging();
}
